import {
  STATIC_MARKETING_PATHS,
  PARTIAL_DYNAMIC_MARKETING_PATHS,
  MARKETING_SITE_ORIGIN,
} from '~/features/marketing/constants'
import { EMarketingClientPath } from '~/models/api'

const getIsMarketingPath = ({ pathname = '' }: { pathname?: string }) => {
  const isLocalhost = window.location.hostname === 'localhost'

  if (isLocalhost) return false

  const isHomePage = pathname === EMarketingClientPath.home
  const isStaticPath = STATIC_MARKETING_PATHS.some((path) =>
    pathname.startsWith(path),
  )
  const isDynamicPath = PARTIAL_DYNAMIC_MARKETING_PATHS.some((path) =>
    pathname.startsWith(path),
  )

  const isMarketingPath = isHomePage || isStaticPath || isDynamicPath

  return isMarketingPath
}

export const pathToMarketingSiteBuilder = (pathname = '') =>
  `${MARKETING_SITE_ORIGIN}${pathname}`

export default getIsMarketingPath
